<template>
  <div class="guided-search">
    <div v-if="!store.displayStepperModal && !displayReassuranceStep" class="guided-search-content">
      <form-component />
    </div>
    <div v-if="displayReassuranceStep && isMounted" class="guided-search-content">
      <reassurance @next-step="nextStep()" />
    </div>
  </div>
</template>

<script>
import { guidedSearchMixin } from '@organisms/guided-search/guidedSearchMixin';
import FormComponent from './Form.vue';
import Reassurance from './steps/Reassurance.vue';

export default {
  components: {
    FormComponent,
    Reassurance,
  },
  mixins: [ guidedSearchMixin ],
  data() {
    return {
      displayReassuranceStep: true,
      isMounted: false,
    };
  },
  mounted() {
    this.store.setUserData();
    this.isMounted = true;

    // If google tag manager is deactivated, dataLayer always exist
    // @see https://bureaux-a-partager.atlassian.net/browse/MATCH-8158
    if (window.dataLayer === undefined) {
      window.dataLayer = [];
    }
  },
  methods: {
    nextStep() {
      this.displayReassuranceStep = false;
    },
  },
};
</script>
